<template>
  <b-tabs 
    class="supplierDetailTabs" 
    card 
    @activate-tab="changedTabs"  
    v-model="currentTab" 
    ref="detailTabs"
  >
    <fieldset :disabled="!isediting">
      <!-- 首页 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="home"></feather>{{ $t("Lbl_Home") }}
        </template>
        <component  is="Home" ref="home"  :simulatedSupplier="simulatedSupplier"  v-if="currentTab==0" :key="simulatedSupplier.empCompanyId"
        />
      </b-tab>
      
      <!-- 销售线索：广告审批入口隐藏标题，同时隐藏空 nav-item，避免占位空白 -->
      <b-tab
        :active="currentTab === CurrentTab.tab"
        :title-item-class="fromPage === 'Ad' ? 'd-none' : null"
      >
        <template slot="title" v-if="fromPage!='Ad'">
          <feather type="message-square"></feather>{{ $t("lbl_EMPBE_SalesLead_SalesLead") }}
        </template>
        <component   is="SalesLead"  ref="salesLead"  :simulatedSupplier="simulatedSupplier"  v-if="currentTab==1" :key="simulatedSupplier.empCompanyId"
        />
      </b-tab>
      
      <!-- 公司信息 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="aperture"></feather>{{ $t("lbl_EMPBE_CompanyInfo") }}
        </template>
        <component  is="companyInfoCenter"  ref="companyInfo"  :supplierId="supplierId"  v-if="currentTab==2"  :key="'company_' + supplierId"
        />
      </b-tab>
      
      <!-- 产品资料 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="shopping-bag"></feather>{{ $t("lbl_EMPBE_ProductInfo") }}
        </template>
        <component is="productInfoCenter"  ref="productInfo" v-if="supplierId&&currentTab==3" :supplierId="supplierId"  :key="'product_' + supplierId"
        />
      </b-tab>
    </fieldset>
    
    <!-- 广告信息 -->
    <b-tab :active="currentTab === CurrentTab.tab">
      <template slot="title">
        <feather type="compass"></feather>{{ $t("lbl_EMPBE_AdInfo") }}
      </template>
      <component is="adInfoCenter" ref="adInfo" v-if="currentTab==4" :supplierId="supplierId" :key="'ad_' + supplierId" @adTabChange="adTabChangeFunc"
      />
    </b-tab>
    
    <!-- 报告：广告审批入口隐藏标题与空 nav-item -->
    <b-tab
      :active="currentTab === CurrentTab.tab"
      :title-item-class="fromPage === 'Ad' ? 'd-none' : null"
    >
      <template slot="title" v-if="fromPage!='Ad'">
        <img 
          style="padding-bottom: 8px; margin-right: 10px;" 
          :src="currentTab === 5 ? 
            'https://cdn.adsalecdn.com/EMP/Backend/Images/EmpBackReportIconNone.png' : 
            'https://cdn.adsalecdn.com/EMP/Backend/Images/EmpBackReportIcon.png'"
        >
        <span style="position: relative; top: 8px;">{{ $t("lbl_EMPBE_ReportAll") }}</span>
      </template>
      <component is="Report" ref="report" :IsStrus="0"  v-if="currentTab==5" :supplierId="supplierId" :key="'report_' + supplierId"
      />
    </b-tab>
    
    <!-- 管理用户：非超管或广告审批入口时隐藏空 nav-item -->
    <b-tab
      :active="currentTab === CurrentTab.tab"
      :title-item-class="(isSuperAdmin && fromPage !== 'Ad') ? null : 'd-none'"
    >
      <template slot="title" v-if="isSuperAdmin&&fromPage!='Ad'">
        <feather type="users"></feather>{{ $t("lbl_EMPBE_ManageUsers") }}
      </template>
      <component 
        :is="tabList[currentTab]?.name" 
        ref="myUsers" 
        v-if="currentTab==6" 
        :companyId="validSupplierId" 
        :key="supplierId"
      />
    </b-tab>


    <!-- 商業登記（放在操作日誌前；管理員審批用，非供應商自管） -->
    <b-tab>
      <template slot="title">
        <feather type="file-text"></feather>{{ $t("lbl_EMPBE_BusinessDocuments") }}
      </template>
      <component
        is="SupplierBusinessDocuments"
        ref="businessDocuments"
        :supplierId="supplierId"
        :simulatedSupplier="simulatedSupplier"
        :show-approval-actions="false"
        v-if="currentTab==7"
        :key="'br_' + supplierId"
      />
    </b-tab>

    <!-- 操作日志（放最后，避免影响原有 Tab 索引/逻辑） -->
    <b-tab>
      <template slot="title">
        <feather type="file-text"></feather>{{ $t("lbl_EMPBE_OpLog_TabTitle") }}
      </template>
      <component
        is="SupplierOperationLog"
        ref="operationLog"
        :supplierId="supplierId"
        :simulatedSupplier="simulatedSupplier"
        v-if="currentTab==8"
        :key="'oplog_' + supplierId"
      />
    </b-tab>
    
    <div slot="tabs-end" class="mr-auto"></div>

    <!-- 底部按钮 -->
    <div class="customizer-formbutton" v-if="$route.params.id" style="bottom:30px">
      <b-button-group>
        <button class="btn btn-light btn-lg">
          <i class="fa fa-trash-o m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
        </button>
        <b-dropdown text="Preview " size="lg" variant="primary">
          <b-dropdown-item>
            <i class="icofont icofont-monitor m-r-5"></i>{{ $t("lbl_EMPBE_PC") }}
          </b-dropdown-item>
          <b-dropdown-item>
            <i class="icofont icofont-android-tablet m-r-5"></i>{{ $t("lbl_EMPBE_Mobile") }}
          </b-dropdown-item>
        </b-dropdown>
        <button class="btn btn-outline-primary btn-lg">
          <i class="icofont icofont-undo m-r-5"></i>{{ $t("lbl_cancel") }}
        </button>
        <button class="btn btn-primary btn-lg">
    
       <!-- <span v-if="isProductInfo"> <i class="fa fa-save m-r-5" ></i>
        <span v-if="productStatus==1">{{ $t("EMPBE_CompanyInfoCenter_btnSubmit") }}  </span>      
        <span v-else>{{ $t("lbl_EMPBE_Save") }}  </span> 
      </span>  -->
       <i class="fa fa-save m-r-5"></i>{{ $t("lbl_EMPBE_Save") }} 
        </button>
        <button class="btn btn-success btn-lg">
          <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_Submit") }}
        </button>
      </b-button-group>
    </div>
    
    <div class="customizer-formbutton" v-if="currentTab != 0 && !['MyUsers','SupplierOperationLog','SupplierBusinessDocuments'].includes(CurrentTab.name)">
      <b-button-group>
        <b-button 
          variant="outline-success btn-lg m-r-5" 
          v-if="showAdApproveButton" 
          @click="todoApproval"
        >
          {{ $t("lbl_EMPBE_Approve") }}
        </b-button>
        <b-button 
          variant="outline-secondary btn-lg m-r-5" 
          v-if="CurrentTab.name === 'adInfoCenter' && (isAdPendingApproval || isAdRejected || isAdApprovalApproval)"
          @click="todoAdRejectFromPage"
        >
          {{ $t(isAdLaunchOnline ? 'lbl_EMPBE_Delist' : 'lbl_EMPBE_Reject') }}
        </b-button>
        <b-button 
          variant="outline-dark btn-lg m-r-5" 
          v-if="!isediting && CurrentTab.editable" 
          @click="isediting = true"
        >
          {{ $t('lbl_EMPBE_Modify') }}
        </b-button>
        <span  v-if="currentTab!=3">
        <b-button 
          variant="outline-info btn-lg m-r-5" 
          v-if="isediting && CurrentTab.name != 'adInfoCenter'" 
          :disabled="isSaveLocked"
          @click="todoSave"
        >
          {{ $t('lbl_EMPBE_Save2') }}
        </b-button>
        <b-button 
          variant="light btn-lg m-r-5" 
          v-if="isediting && CurrentTab.name != 'adInfoCenter'" 
          @click="isediting = false"
        >
          {{ $t("lbl_cancel") }}
        </b-button>
        </span>
      </b-button-group>
    </div>

    <!-- 驳回侧边栏 -->
    <b-sidebar 
      ref="rejectSidebar" 
      :id="'disablepopup_reject_' + supplierId" 
      :title="$t('lbl_EMPBE_Reject')"
      bg-variant="white" 
      right 
      backdrop 
      :shadow="true"
    >
      <DisableItemVue 
        ref="DisableItemVue_reject" 
        @todo="todoReject"
        :rejectType="'ads'"
      />
    </b-sidebar>
  </b-tabs>
</template>

<script>
import { computed } from "vue";
import { mapGetters } from 'vuex';
import companyInfoCenter from './supplierCompanyInfo.vue';
import productInfoCenter from './supplierProductInfo.vue';
import Report from '../../Report/index.vue';
import DisableItemVue from '../RightPopUp/DisableItem.vue';
import adInfoCenter from './SupplierAdInfo.vue';
import { adService, userService } from '@/_services';
import { buildApprovalConfirmDialogBody } from '@/_helpers/approvalConfirmDialog';
import Home from '../../dashboard/default.vue';
import SalesLead from '../../salesLead/default.vue';
import MyUsers from '../../UserSetting/MyUsers.vue';
import SupplierOperationLog from './supplierOperationLog.vue';
import SupplierBusinessDocuments from '@/pages/management/supplierDetail/supplierBusinessDocuments.vue';

export default {
  name: 'SupplierDetailTabs',
  components: {
    companyInfoCenter,
    productInfoCenter,
    adInfoCenter,
    DisableItemVue,
    Report,
    Home,
    SalesLead,
    SupplierOperationLog,
    SupplierBusinessDocuments,
    MyUsers,
  },
  provide() {
    return {
      permissionData: computed(() => this.permissionData),
      openSupplierBusinessDocuments: () => this.openBusinessDocumentsTab(),
    };
  },
  props: ['supplierId', 'text_data', 'simulatedSupplier', 'sidebarStrus',"openTabIndex","fromPage"],
  data() {
    return {
      permissionData: null,
      //visitedTabs: [0],
      currentTab: 0,
      isediting: true,
      rejectReason: '',
      isFirstLoad: true,
      isAdPendingApproval:false,
      isAdApprovalApproval:false,
      isAdRejected:false,
      isAdLaunchOnline:false,
      adApprovalStatusCode:'',
      tabList: [
        {
          name: 'Home',
          tab: 0,
          editable: true
        },
        {
          name: 'SalesLead',
          tab: 1,
          editable: true
        },
        {
          name: 'companyInfoCenter',
          tab: 2,
          editable: true
        },
        {
          name: 'productInfoCenter',
          tab: 3,
          editable: true
        },
        {
          name: 'adInfoCenter',
          tab: 4,
          editable: true
        },
        {
          name: 'Report',
          tab: 5,
          editable: false
        },
        {
          name: 'MyUsers',
          tab: 6,
          editable: false
        },
        {
          name: 'SupplierBusinessDocuments',
          tab: 7,
          editable: false
        },
        {
          name: 'SupplierOperationLog',
          tab: 8,
          editable: false
        }
      ],
      isProductInfo:false,
      productId:0,
      productStatus:-1,
      isSaveLocked: false,
      saveLockTimer: null,
      saveDebounceMs: 1200,
    };
  },
  computed: {
    CurrentTab() {
      return this.tabList.find(tab => tab.tab === this.currentTab);
    },
    isSuperAdmin() {
      const currentUser = this.$store?.state?.authentication?.user;
      return currentUser && currentUser.IsFullAccess === true;
    },
    validSupplierId() {
      if (!this.supplierId) {
        return null;
      }
      
      const id = Number(this.supplierId);
      
      if (isNaN(id) || id <= 0 || id === -1) {
        return null;
      }
      
      return id;
    },
    ...mapGetters({
      getPermissionJsonByUser: 'responsePermission/getPermissionJsonByUser',
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId || this.user?.empCompanyId || '';
    },
    langid() {
      return localStorage.getItem('currentLangId');
    },
    /** 人工审批中 / 已驳回才显示批准；审批中(AI)不可人工批准 */
    showAdApproveButton() {
      if (this.CurrentTab?.name !== 'adInfoCenter') return false;
      const code = this.normalizeAdApprovalStatusCode(this.adApprovalStatusCode);
      return code === 'PA' || code === 'R';
    },
    GetTabRef() {
      return "tab" + this.TabIndex;
    },
  },
  watch: {
      sidebarStrus(val) {
        if (!val) {
          this.currentTab = 0;
          return;
        }
        // 打开时按 URL type/tab 定位，避免被重置成 Home
        this.applyUrlTab();
      },
    currentTab(newTab, oldTab) {
      const myUsersTabIndex = this.getTabByName('MyUsers');
      
      if (oldTab === myUsersTabIndex && newTab !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      if (newTab === myUsersTabIndex && oldTab !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
    },
    supplierId: {
      handler() {
        this.refresh();
      },
      immediate: true
    }, 
  },
  mounted() {
    console.log('fromPage'+this.fromPage)
    // 有 URL deep-link 时不要强制回 Home，交给 applyUrlTab / refresh 处理
    const q = this.$route.query || {};
    if (!(q.type || q.tab || q.productId || q.catalogId)) {
      this.currentTab = 0;
    }
  },
  beforeDestroy() {
    if (this.saveLockTimer) {
      clearTimeout(this.saveLockTimer);
      this.saveLockTimer = null;
    }
  },
  methods: {
    lockSaveAction() {
      this.isSaveLocked = true;
      if (this.saveLockTimer) {
        clearTimeout(this.saveLockTimer);
      }
      this.saveLockTimer = setTimeout(() => {
        this.isSaveLocked = false;
        this.saveLockTimer = null;
      }, this.saveDebounceMs);
    },

    /**
     * 判断是否应该渲染当前tab
     */
    // shouldRenderTab(tabIndex) {
    //   return this.visitedTabs.includes(tabIndex);
    // },
    
    adTabChangeFunc(approvalStatus, isLaunchOnline) {
      const code = this.normalizeAdApprovalStatusCode(approvalStatus);
      // 驳回：审批中 / 人工审批中均可；批准仅人工审批中（见 showAdApproveButton）
      this.isAdPendingApproval = code === 'P' || code === 'PA';
      this.isAdApprovalApproval = code === 'A';
      this.isAdRejected = code === 'R';
      this.isAdLaunchOnline = !!isLaunchOnline;
      this.adApprovalStatusCode = approvalStatus || '';
    },
    
    getTabByName(name) {
      const tab = this.tabList.find(tab => tab.name === name);
      return tab ? tab.tab : 0;
    },
    openBusinessDocumentsTab() {
      this.currentTab = this.getTabByName('SupplierBusinessDocuments');
    },
    
    /**
     * 切换标签页
     */
    changedTabs(newTabIndex, prevTabIndex, bvEvent) {
      const myUsersTabIndex = this.getTabByName('MyUsers');
      
      if (prevTabIndex === myUsersTabIndex && newTabIndex !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      if (newTabIndex === myUsersTabIndex && prevTabIndex !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      // Reset product detail view when entering product tab（URL deep-link 时跳过）
      const hasUrlDetail = !!(this.$route.query.productId || this.$route.query.catalogId);
      if (newTabIndex === 3 && this.$refs.productInfo && !hasUrlDetail) {
        this.$refs.productInfo.temp_productId = 0;
        this.$refs.productInfo.temp_catalogId = 0;
        this.$refs.productInfo.isShowDetail = false;
      }

      // 操作日志：v-if 挂载后由子组件按默认日期拉一次列表（nextTick 确保 ref 就绪）
      const oplogTabIndex = this.getTabByName('SupplierOperationLog');
      if (newTabIndex === oplogTabIndex) {
        this.$nextTick(() => {
          const oplog = this.$refs.operationLog;
          if (oplog && typeof oplog.bootstrapFromTab === 'function') {
            oplog.bootstrapFromTab();
          }
        });
      }
    },
    
    /** 根据 URL 的 type / tab / productId / catalogId 打开对应 tab */
    applyUrlTab() {
      const q = this.$route.query || {};
      const key = String(q.type || q.tab || "").toLowerCase(); 
      const tabMap = {
        home: "Home",
        saleslead: "SalesLead",
        company: "companyInfoCenter",
        product: "productInfoCenter", 
        catalog: "productInfoCenter",
      };
      let tabIndex = this.openTabIndex > 0 ? Number(this.openTabIndex) : 0;
      //console.log('tabMap[key]'+tabMap[key])
      if (key && tabMap[key]) {
        tabIndex = this.getTabByName(tabMap[key]);
      } else if (q.productId || q.catalogId) {
        tabIndex = this.getTabByName("productInfoCenter");
      }
      this.currentTab = tabIndex;
      //console.log('this.currentTab'+this.currentTab)
    },

    /**
     * 刷新页面
     */
    refresh() {
      if (this.companyid) {
        this.GetSysCompanySponsorType();
      }
      if (this.$refs.rejectSidebar) {
        this.$refs.rejectSidebar.hide();
      }

      // URL deep-link 优先，避免被 openTabIndex=0 覆盖
      const q = this.$route.query || {};
      if (q.type || q.tab || q.productId || q.catalogId) {
        this.applyUrlTab();
      } else {
        this.currentTab = this.openTabIndex > 0 ? Number(this.openTabIndex) : 0;
      }
      console.log('currentTab:' + this.currentTab);
    },
    
    /**
     * 保存当前标签页
     */
    async todoSave() { 
      if (this.isSaveLocked) return;
      this.lockSaveAction();
      // 产品资料  已不在这里处理逻辑
      // if (this.currentTab === this.getTabByName('productInfoCenter')) {
      //   this.todoProductSave();
      //   return;
      // }
      
      this.$swal({
        text: this.$t('lbl_EMPBE_ConfirmToSave'),
        showCancelButton: true,
        confirmButtonText: this.$t('lbl_EMPBE_Confirm'),
        cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
      }).then(async (res) => {
        if (res.isConfirmed) {
          switch (this.CurrentTab.name) {
            case 'companyInfoCenter':
              await Promise.resolve(this.todoCompanySave());
              break;
            case 'adInfoCenter':
              await Promise.resolve(this.todoAdSave());
              break;
          }
        }
      });
    },
    
    /**
     * 保存子组件
     */
    SaveChildPage() {
      return new Promise((resolve) => {
        if (this.$refs.productInfo && this.$refs.productInfo[this.GetTabRef]) {
          this.$refs.productInfo[this.GetTabRef].Save().then(resolve);
        } else {
          resolve(true);
        }
      });
    },
    
    todoCompanySave() {
      if (this.$refs.companyInfo) {
        this.$refs.companyInfo.todoSave();
      }
    },
    
    // todoProductSave() {
    //   if (this.$refs.productInfo) {
    //     this.$refs.productInfo.todoSaveSubmit();
    //   }
    // },
    
    todoAdSave() {
      if (this.$refs.adInfo) {
        this.$refs.adInfo.todoSave();
      }
    },

    normalizeAdApprovalStatusCode(status) {
      const s = String(status || '').trim();
      if (['P', 'pending', 'aiReviewing'].includes(s)) return 'P';
      if (['PA', 'pendingManualAudit'].includes(s)) return 'PA';
      if (['A', 'live', 'pendingGoLive'].includes(s)) return 'A';
      if (['R', 'rejected'].includes(s)) return 'R';
      return s;
    },

    confirmAdApprovalDialog({ isReject = false, isDelist = false } = {}) {
      const title = isDelist
        ? this.$t('lbl_EMPBE_Ad_ConfirmDelistTitle')
        : this.$t(isReject
          ? 'lbl_EMPBE_Ad_ConfirmRejectTitle'
          : 'lbl_EMPBE_Ad_ConfirmApproveTitle');
      const html = isDelist
        ? this.$t('lbl_EMPBE_Ad_ConfirmDelistBody', {
          fromStatus: this.$t('lbl_EMPBE_Product_Online'),
          toStatus: this.$t('lbl_EMPBE_Product_Offline'),
        })
        : buildApprovalConfirmDialogBody(this, {
          isReject,
          currentStatusCode: this.normalizeAdApprovalStatusCode(this.adApprovalStatusCode),
        });
      const confirmButtonText = isDelist
        ? this.$t('lbl_EMPBE_Delist')
        : this.$t(isReject
          ? 'lbl_EMPBE_ProductInfo_ConfirmRejectOk'
          : 'lbl_EMPBE_ProductInfo_ConfirmApproveOk');
      return this.$swal({
        title,
        html,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
        customClass: (isReject || isDelist)
          ? 'AlertDialog-DEL'
          : 'AlertDialog-SaveSucess AlertDialog-Approve',
        reverseButtons: true,
        confirmButtonColor: (isReject || isDelist) ? '#DC3545' : '#51BB25',
      });
    },
    
    async todoApproval() {
      if (this.normalizeAdApprovalStatusCode(this.adApprovalStatusCode) === 'P') return;
      try {
        const prepared = await this.$refs.adInfo?.prepareAdApproval?.('A');
        if (!prepared?.ok) return;
        this.rejectReason = '';
      } catch (e) {
        return;
      }
      const res = await this.confirmAdApprovalDialog({ isReject: false });
      if (res?.isConfirmed) {
        try {
          const Params = await this.AdGetParam('APPROVAL', 'A');
          const response = await adService.adApprove(Params);
          this.handleAdApproveResponse(response, this.$t("lbl_EMPBE_Ad_ApproveSuccess"));
        } catch (err) {
        }
      }
    },

    async todoAdRejectFromPage() {
      let overallReason = '';
      try {
        const prepared = await this.$refs.adInfo?.prepareAdApproval?.('R');
        if (!prepared?.ok) return;
        overallReason = prepared.overallReason || '';
      } catch (e) {
        return;
      }
      const res = await this.confirmAdApprovalDialog({
        isReject: true,
        isDelist: this.isAdLaunchOnline,
      });
      if (res?.isConfirmed) {
        this.rejectReason = overallReason;
        const Params = await this.AdGetParam('APPROVAL', 'R');
        adService.adApprove(Params)
          .then((response) => {
            const handled = this.handleAdApproveResponse(response, this.$t("lbl_EMPBE_Ad_RejectSuccess"));
            if (handled) {
              this.rejectReason = '';
            } else if ((response.customStatus || response.CustomStatus) !== 'AllSkipped') {
              this.$swal({
                text: this.$t("lbl_EMPBE_RejectFailed"),
                showCancelButton: false,
              });
            }
          });
      }
    },
    
    todoReject(val) {
      this.confirmAdApprovalDialog({
        isReject: true,
        isDelist: this.isAdLaunchOnline,
      }).then(async (res) => {
        if (res.isConfirmed) {
          this.rejectReason = val;
          const Params = await this.AdGetParam('APPROVAL', 'R');
          
          adService.adApprove(Params)
            .then((response) => {
              const handled = this.handleAdApproveResponse(response, this.$t("lbl_EMPBE_Ad_RejectSuccess"));
              if (handled) {
                this.rejectReason = '';
                this.$refs.rejectSidebar.hide();
                this.$refs.DisableItemVue_reject.text_data = '';
              } else if ((response.customStatus || response.CustomStatus) !== 'AllSkipped') {
                this.$swal({
                  text: this.$t("lbl_EMPBE_RejectFailed"),
                  showCancelButton: false,
                });
              }
            });
        }
      });
    },

    handleAdApproveResponse(response, successText) {
      const customStatus = response.customStatus || response.CustomStatus || '';
      if (customStatus === 'AllSkipped') {
        const msg = response.msg || response.Msg || [];
        this.$swal({
          text: (Array.isArray(msg) && msg[0]) || '广告状态已变更，请刷新后查看',
          showCancelButton: false,
        });
        this.$refs.adInfo.refresh();
        return false;
      }
      if (response.isSuccessful && response.statusCode === 200) {
        // PartialSkipped 不再单独弹窗；成对 Banner 已只批 PC，其余按正常成功提示
        this.$swal({
          title: successText,
          showCancelButton: false,
          confirmButtonText: this.$t('lbl_EMPBE_Confirm'),
          confirmButtonColor: '#7366FF',
          customClass: 'AlertDialog-SaveSucess',
        });
        this.$refs.adInfo.refresh();
        return true;
      }
      return false;
    },
    
    async AdGetParam(StatusType, StatusCode) {
      const adRecords = this.$refs.adInfo?.getAdDetails?.() || [];
      return {
        adDetailIds: adRecords.map(item => item.adDetailId).join(','),
        approvalIds: adRecords.map(item => item.approvalId || item.ApprovalId || '').join(','),
        statusCode: StatusCode,
        rejectReason: this.rejectReason,
        // updatedBy 由后端 JWT accountUserId 写入，勿再传 empCompanyId/accountId
        updatedBy: '',
        remark: ''
      };
    },
    
    getAdDetailIds() {
      const adRecord = this.$refs.adInfo?.getAdDetails?.() || [];
      return adRecord.map(item => item.adDetailId).join(',');
    },
    
    GetSysCompanySponsorType() {
      if (!this.companyid) return;
      
      userService.GetSysCompanySponsorType({ CompanyId: this.companyid })
        .then(res => {
          if (res.isSuccessful) {
            this.permissionData = this.getPermissionJsonByUser({ 
              user: res.data 
            });
          }
        });
    },
    parentHandlBtn(productId,status){
    this.isProductInfo=true;
    this.productId=productId;
    this.productStatus=status
    }
  }
};
</script>
<style >
 .supplierDetailTabs fieldset {
  border: none; 
}
  #supplier .card-header:nth-child(1) {
    width: 95%;
    margin-left: 32px;
}  
  #supplier .card-header:nth-child(n+2)  {
    width: unset;
    margin-left: unset !important;
}  
  #ContactRightpopup .card-header {
    width: unset;
    margin-left: unset !important;
} 
</style>